<template>
  <v-overlay absolute :value="showLoading" color="#fff" opacity="0.9">
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showLoading: this.value,
    }
  },

  watch: {
    value(val) {
      this.showLoading = val
    },

    showLoading(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style></style>
